import { API_TYPES, ApiType } from '@workspace/lib/constants/api-provider';
import type { AnalyticsEventOptions } from '@workspace/lib/types/analytics';
import type { ApiRequestBody } from '@workspace/lib/types/api-provider';
import { getDynamicApiHeaders } from '@workspace/lib/utils/api-headers';

export const sendRestAnalyticsEvent = async (
  eventData: any,
  options: AnalyticsEventOptions,
) => {
  try {
    const { applicationId, messageId, userId } = options;
    const customHeaders = getDynamicApiHeaders({
      messageId,
      userId,
      batchId: applicationId,
    });

    const controller = new AbortController();
    const timeoutId = setTimeout(
      () => controller.abort(),
      options?.timeout || 10000,
    );

    const analyticsUrl = `${API_TYPES[ApiType.ANALYTICS].apiUrl}/analytic-events`;

    const response = await fetch('/api/api-request', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        url: analyticsUrl,
        method: 'POST',
        body: eventData,
        customHeaders,
        apiType: ApiType.ANALYTICS,
      } as ApiRequestBody),
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.error || `HTTP ${response.status}: ${response.statusText}`,
      );
    }
  } catch (error) {
    console.warn('REST analytics error:', error);
  }
};
